<template>
  <div class="desktop">
    <app-header :showCollapse="false"></app-header>
    <div class="grid-container">
      <div
        v-for="(item, index) in menuList"
        :key="'menu' + index"
        class="gridItem"
        @click="goToUrl(item)"
      >
        <img
          style="width: 56px; height: 56px; margin-left: 16px"
          :src="getImgUrl(item.icon)"
          alt=""
        />
        <div
          style="
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 100px;
            height: 100px;
            margin-left: 32px;
          "
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginApi from '@/api/login';
import AppHeader from '@/components/AppHeader';
export default {
  name: 'Desktop',
  components: {
    AppHeader,
  },
  data() {
    return {
      menuList: [],
    };
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    getImgUrl(path) {
      if (path) {
        try {
          return require('../../assets/desktop/' + path + '.png');
        } catch (e) {
          return '';
        }
      }
    },
    getMenu() {
      LoginApi.queryHomeMenuInfo().then((res) => {
        // console.log(res);
        this.menuList = res.data.data;
        // this.menuList = this.menuList.concat(res.data.data);
      });
    },
    goToUrl(row) {
      if (row.url) {
        this.$router.push(row.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.desktop {
  .grid-container {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    padding: 60px;
    .gridItem {
      height: 100px;
      width: 200px;
      margin: 20px;
      place-self: center;
      display: grid;
      grid-template-columns: 30% 70%;
      align-items: center; /* 垂直居中 */
      cursor: pointer;
    }
  }
}
</style>
